/* Contains the default layouts structure for each page */

import { v4 as uuid4 } from "uuid"
import { MODULES } from "@/store/constants/references"
import store from "@/store"

const getPageDefaultLayout = (page_slug, isModuleActivated) => {
  let layout = null
  let slug = null
  let name = null

  if (page_slug == "home") {
    layout = [
      {
        h: 18,
        w: 72,
        x: 0,
        y: 0,
        id: uuid4(),
        maxH: 72,
        minH: 18,
        minW: 48,
        name: window.$t("My Due Dates & Events"),
        props: {
          hidden: false,
          component_type: "calendar",
          component_props: {
            label: window.$t("My Due Dates & Events"),
            view_by: ["plans", "goals", "tasks", "interactions"]
          },
          component_reference: uuid4()
        },
        view_by: ["plans", "goals", "tasks", "interactions"],
        visible: true,
        preserveAspectRatio: false
      },
      {
        h: 24,
        w: 72,
        x: 0,
        y: 18,
        id: uuid4(),
        maxH: 72,
        minH: 24,
        minW: 48,
        name: window.$t("My Activities"),
        moved: false,
        props: {
          hidden: false,
          component_type: "action_table",
          component_props: {
            label: "My Activities ",
            view_by: ["plans", "goals", "tasks"]
          },
          component_reference: uuid4()
        },
        view_by: ["plans", "goals", "tasks"],
        visible: true,
        preserveAspectRatio: false
      },
      {
        h: 24,
        w: 72,
        x: 0,
        y: 42,
        id: uuid4(),
        maxH: 72,
        minH: 24,
        minW: 48,
        name: window.$t("Customer Interactions"),
        moved: false,
        props: {
          hidden: false,
          component_type: "action_table",
          component_props: {
            label: window.$t("Customer Interactions"),
            view_by: ["interactions"]
          },
          component_reference: uuid4()
        },
        view_by: ["interactions"],
        visible: true,
        preserveAspectRatio: false
      }
    ]
    let view_by = []
    isModuleActivated(MODULES.PROSPECTING_GROWTH_MATRIX) && view_by.push("growth_matrix")
    isModuleActivated(MODULES.PROSPECTING_SUGGESTED) && view_by.push("suggested")
    if (view_by.length) {
      layout.push({
        h: 18,
        w: 72,
        x: 0,
        y: 66,
        id: uuid4(),
        maxH: 72,
        minH: 24,
        minW: 24,
        name: window.$t("New Suggested Leads"),
        moved: false,
        props: {
          hidden: false,
          component_type: "lead_table",
          component_props: {
            label: window.$t("RevSetter Leads"),
            view_by: view_by
          },
          component_reference: uuid4()
        },
        view_by: view_by,
        visible: true,
        preserveAspectRatio: false
      })
    }

    // if forecasting module is a activated and user has forecasts
    if (isModuleActivated(MODULES.FORECASTING) && store.state.data.user_forecasts.length) {
      layout.push({
        h: 24,
        w: 72,
        x: 0,
        y: 14,
        id: uuid4(),
        maxH: 72,
        minH: 24,
        minW: 24,
        name: window.$t("My Outstanding Cases"),
        moved: false,
        props: {
          hidden: false,
          component_type: "forecast_table",
          component_props: {
            label: window.$t("My Outstanding Cases"),
            view_by: null,
            objectType: store.state.data.user_forecasts[0].object_type,
            forecast_name: store.state.data.user_forecasts[0].id
          },
          component_reference: uuid4()
        },
        view_by: null,
        visible: true,
        forecast_name: store.state.data.user_forecasts[0].id,
        preserveAspectRatio: false
      })
    }
    slug = page_slug
    name = window.$t("Home")
  }

  if (page_slug == "home_upcoming_renewals") {
    layout = [
      {
        h: 6,
        w: 18,
        x: 0,
        y: 0,
        id: "home_upcoming_renewal_forecast_arr",
        maxH: 72,
        minH: 6,
        minW: 12,
        moved: false,
        props: {
          hidden: false,
          component_type: "forecasting_metric",
          component_props: {
            label: window.$t("ARR"),
            dataSource: "home_upcoming_renewal_forecast_table",
            metricName: "arr"
          },
          component_reference: "home_upcoming_renewal_forecast_arr"
        },
        preserveAspectRatio: false
      },
      {
        h: 6,
        w: 18,
        x: 0,
        y: 6,
        id: "home_upcoming_renewal_forecast_mrr",
        maxH: 72,
        minH: 6,
        minW: 12,
        moved: false,
        props: {
          hidden: false,
          component_type: "forecasting_metric",
          component_props: {
            label: window.$t("MRR"),
            dataSource: "home_upcoming_renewal_forecast_table",
            metricName: "mrr"
          },
          component_reference: "home_upcoming_renewal_forecast_mrr"
        },
        preserveAspectRatio: false
      },
      {
        h: 12,
        w: 18,
        x: 18,
        y: 0,
        id: "home_upcoming_renewal_forecast_grr",
        maxH: 72,
        minH: 6,
        minW: 12,
        moved: false,
        props: {
          hidden: false,
          component_type: "forecasting_metric",
          component_props: {
            label: window.$t("GRR"),
            dataSource: "home_upcoming_renewal_forecast_table",
            metricName: "grr"
          },
          component_reference: "home_upcoming_renewal_forecast_grr"
        },
        preserveAspectRatio: false
      },
      {
        h: 12,
        w: 18,
        x: 36,
        y: 0,
        id: "home_upcoming_renewal_forecast_nrr",
        maxH: 72,
        minH: 6,
        minW: 12,
        moved: false,
        props: {
          hidden: false,
          component_type: "forecasting_metric",
          component_props: {
            label: window.$t("NRR"),
            dataSource: "home_upcoming_renewal_forecast_table",
            metricName: "nrr"
          },
          component_reference: "home_upcoming_renewal_forecast_nrr"
        },
        preserveAspectRatio: false
      },
      {
        h: 12,
        w: 18,
        x: 54,
        y: 0,
        id: "home_upcoming_renewal_forecast_bookings",
        maxH: 72,
        minH: 6,
        minW: 12,
        moved: false,
        props: {
          hidden: false,
          component_type: "forecasting_metric",
          component_props: {
            label: window.$t("Bookings"),
            dataSource: "home_upcoming_renewal_forecast_table",
            metricName: "bookings"
          },
          component_reference: "home_upcoming_renewal_forecast_bookings"
        },
        preserveAspectRatio: false
      },
      {
        h: 36,
        w: 72,
        x: 0,
        y: 12,
        id: "home_upcoming_renewal_forecast_table",
        maxH: 72,
        minH: 24,
        minW: 24,
        name: window.$t("My Outstanding Cases"),
        moved: false,
        props: {
          hidden: false,
          component_type: "forecast_table",
          component_props: {
            label: window.$t("My Upcoming Renewals"),
            view_by: null,
            objectType: store.state.data.user_forecasts[0]?.object_type,
            forecast_name: store.state.data.user_forecasts[0]?.id
          },
          component_reference: "home_upcoming_renewal_forecast_table"
        },
        view_by: null,
        visible: true,
        forecast_name: store.state.data.user_forecasts[0]?.id,
        preserveAspectRatio: false
      }
    ]
    if (isModuleActivated(MODULES.FORECASTING) && store.state.data.user_forecasts.length == 0) {
      // pop the last
      layout.pop()
    }
    slug = page_slug
    name = window.$t("My Upcoming Renewals")
  }

  if (page_slug == "home_today") {
    layout = [
      {
        h: 24,
        w: 72,
        x: 0,
        y: 6,
        id: "home_today_tasks",
        maxH: 72,
        minH: 24,
        minW: 48,
        moved: false,
        props: {
          hidden: false,
          component_type: "action_table",
          component_props: {
            label: window.$t("Today's tasks"),
            view_by: ["tasks"],
            connectTo: "all_records",
            initialFilter: {
              relative_due_date: "today"
            }
          },
          component_reference: "home_today_tasks"
        },
        preserveAspectRatio: false
      },
      {
        h: 24,
        w: 72,
        x: 0,
        y: 30,
        id: "home_today_goals",
        maxH: 72,
        minH: 24,
        minW: 48,
        moved: false,
        props: {
          hidden: false,
          component_type: "action_table",
          component_props: {
            label: window.$t("Today's goals"),
            view_by: ["goals"],
            connectTo: "all_records",
            initialFilter: {
              relative_due_date: "today"
            }
          },
          component_reference: "home_today_goals"
        },
        preserveAspectRatio: false
      },
      {
        h: 24,
        w: 72,
        x: 0,
        y: 54,
        id: "home_today_plan",
        maxH: 72,
        minH: 24,
        minW: 48,
        moved: false,
        props: {
          hidden: false,
          component_type: "action_table",
          component_props: {
            label: window.$t("Today's plans"),
            view_by: ["plans"],
            connectTo: "all_records",
            initialFilter: {
              relative_due_date: "today"
            }
          },
          component_reference: "home_today_plan"
        },
        preserveAspectRatio: false
      },
      {
        h: 6,
        w: 72,
        x: 0,
        y: 0,
        id: "home_today_text_title",
        maxH: 72,
        minH: 6,
        minW: 6,
        moved: false,
        props: {
          component_type: "text",
          component_props: {
            label: " ",
            description:
              `<h6 class="ql-align-center"><strong>` +
              window.$t("Welcome to Today's Activities page where you can find all tasks, goals and plans due today.") +
              `</strong></h6>`,
            backgroundColor: "white"
          }
        },
        preserveAspectRatio: false
      }
    ]

    slug = page_slug
    name = window.$t("Today")
  }

  if (page_slug == "home_this_week") {
    layout = [
      {
        h: 24,
        w: 72,
        x: 0,
        y: 6,
        id: "home_this_week_tasks",
        maxH: 72,
        minH: 24,
        minW: 48,
        moved: false,
        props: {
          hidden: false,
          component_type: "action_table",
          component_props: {
            label: window.$t("This week's tasks"),
            view_by: ["tasks"],
            connectTo: "all_records",
            initialFilter: {
              relative_due_date: "this_week"
            }
          },
          component_reference: "home_this_week_tasks"
        },
        preserveAspectRatio: false
      },
      {
        h: 24,
        w: 72,
        x: 0,
        y: 30,
        id: "home_this_week_goals",
        maxH: 72,
        minH: 24,
        minW: 48,
        moved: false,
        props: {
          hidden: false,
          component_type: "action_table",
          component_props: {
            label: window.$t("This week's goals"),
            view_by: ["goals"],
            connectTo: "all_records",
            initialFilter: {
              relative_due_date: "this_week"
            }
          },
          component_reference: "home_this_week_goals"
        },
        preserveAspectRatio: false
      },
      {
        h: 24,
        w: 72,
        x: 0,
        y: 54,
        id: "home_this_week_plan",
        maxH: 72,
        minH: 24,
        minW: 48,
        moved: false,
        props: {
          hidden: false,
          component_type: "action_table",
          component_props: {
            label: window.$t("This week's plans"),
            view_by: ["plans"],
            connectTo: "all_records",
            initialFilter: {
              relative_due_date: "this_week"
            }
          },
          component_reference: "home_this_week_plan"
        },
        preserveAspectRatio: false
      },
      {
        h: 6,
        w: 72,
        x: 0,
        y: 0,
        id: "home_this_week_text_title",
        maxH: 72,
        minH: 6,
        minW: 6,
        moved: false,
        props: {
          component_type: "text",
          component_props: {
            label: " ",
            description:
              '<h6 class="ql-align-center"><strong>' +
              window.$t("Welcome to This Week's Activities page where you can find all tasks, goals and plans due this week.") +
              "</strong></h6>",
            backgroundColor: "white"
          }
        },
        preserveAspectRatio: false
      }
    ]

    slug = page_slug
    name = window.$t("This week")
  }

  if (page_slug == "home_this_month") {
    layout = [
      {
        h: 24,
        w: 72,
        x: 0,
        y: 6,
        id: "home_this_month_tasks",
        maxH: 72,
        minH: 24,
        minW: 48,
        moved: false,
        props: {
          hidden: false,
          component_type: "action_table",
          component_props: {
            label: window.$t("This month's tasks"),
            view_by: ["tasks"],
            connectTo: "all_records",
            initialFilter: {
              relative_due_date: "this_month"
            }
          },
          component_reference: "home_this_month_tasks"
        },
        preserveAspectRatio: false
      },
      {
        h: 24,
        w: 72,
        x: 0,
        y: 30,
        id: "home_this_month_goals",
        maxH: 72,
        minH: 24,
        minW: 48,
        moved: false,
        props: {
          hidden: false,
          component_type: "action_table",
          component_props: {
            label: window.$t("This month's goals"),
            view_by: ["goals"],
            connectTo: "all_records",
            initialFilter: {
              relative_due_date: "this_month"
            }
          },
          component_reference: "home_this_month_goals"
        },
        preserveAspectRatio: false
      },
      {
        h: 24,
        w: 72,
        x: 0,
        y: 54,
        id: "home_this_month_plan",
        maxH: 72,
        minH: 24,
        minW: 48,
        moved: false,
        props: {
          hidden: false,
          component_type: "action_table",
          component_props: {
            label: window.$t("This month's plans"),
            view_by: ["plans"],
            connectTo: "all_records",
            initialFilter: {
              relative_due_date: "this_month"
            }
          },
          component_reference: "home_this_month_plan"
        },
        preserveAspectRatio: false
      },
      {
        h: 6,
        w: 72,
        x: 0,
        y: 0,
        id: "home_this_month_text_title",
        maxH: 72,
        minH: 6,
        minW: 6,
        moved: false,
        props: {
          component_type: "text",
          component_props: {
            label: " ",
            description:
              '<h6 class="ql-align-center"><strong>' +
              window.$t("Welcome to This Month's Activities page where you can find all tasks, goals and plans due this month.") +
              "</strong></h6>",
            backgroundColor: "white"
          }
        },
        preserveAspectRatio: false
      }
    ]

    slug = page_slug
    name = "This month"
  }

  if (page_slug == "home_overdue") {
    layout = [
      {
        h: 24,
        w: 72,
        x: 0,
        y: 6,
        id: "home_overdue_tasks",
        maxH: 72,
        minH: 24,
        minW: 48,
        moved: false,
        props: {
          hidden: false,
          component_type: "action_table",
          component_props: {
            label: window.$t("Overdue tasks"),
            view_by: ["tasks"],
            connectTo: "all_records",
            initialFilter: {
              status: ["overdue"]
            }
          },
          component_reference: "home_overdue_tasks"
        },
        preserveAspectRatio: false
      },
      {
        h: 24,
        w: 72,
        x: 0,
        y: 30,
        id: "home_overdue_goals",
        maxH: 72,
        minH: 24,
        minW: 48,
        moved: false,
        props: {
          hidden: false,
          component_type: "action_table",
          component_props: {
            label: window.$t("Overdue goals"),
            view_by: ["goals"],
            connectTo: "all_records",
            initialFilter: {
              status: ["overdue"]
            }
          },
          component_reference: "home_overdue_goals"
        },
        preserveAspectRatio: false
      },
      {
        h: 24,
        w: 72,
        x: 0,
        y: 54,
        id: "home_overdue_plan",
        maxH: 72,
        minH: 24,
        minW: 48,
        moved: false,
        props: {
          hidden: false,
          component_type: "action_table",
          component_props: {
            label: window.$t("Overdue plans"),
            view_by: ["plans"],
            connectTo: "all_records",
            initialFilter: {
              status: ["overdue"]
            }
          },
          component_reference: "home_overdue_plan"
        },
        preserveAspectRatio: false
      },
      {
        h: 6,
        w: 72,
        x: 0,
        y: 0,
        id: "home_overdue_text_title",
        maxH: 72,
        minH: 6,
        minW: 6,
        moved: false,
        props: {
          component_type: "text",
          component_props: {
            label: " ",
            description:
              '<h6 class="ql-align-center"><strong>' +
              window.$t("Welcome to Overdue Activities page where you can find all tasks, goals and plans that are overdue.") +
              "</strong></h6>",
            backgroundColor: "white"
          }
        },
        preserveAspectRatio: false
      }
    ]

    slug = page_slug
    name = window.$t("Overdue")
  }

  // All the other objects have only three sub pages (overview,actions,checklists)

  return [layout, name, slug]
}

export default getPageDefaultLayout
